import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import SvgSymbol from 'common/components/svg-symbol';
import Tooltip from 'common/components/tooltip';
import * as TooltipType from 'common/enum/tooltip-type';

export default class HelptextTooltip extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    icon: PropTypes.string,
    showIcon: PropTypes.bool,
    tooltipType: PropTypes.string,
  };

  static defaultProps = {
    showIcon: true,
    tooltipType: TooltipType.wide,
  };

  constructor(props) {
    super(props);
    this.toggleTooltip = this.toggleTooltip.bind(this);
  }

  state = {
    tooltipVisible: false,
  };

  getSvgClassName() {
    const classList = ['HelptextTooltip-SvgSymbol'];
    if (!this.props.showIcon) {
      classList.push('HelptextTooltip-SvgSymbol--invisible');
    }
    return classList.join(' ');
  }

  toggleTooltip() {
    this.setState({
      tooltipVisible: !this.state.tooltipVisible,
    });
  }

  render() {
    return (
      <span
        className={'HelptextTooltip'}
        onMouseEnter={this.toggleTooltip}
        onMouseLeave={this.toggleTooltip}>
        <SvgSymbol
          className={this.getSvgClassName()}
          name={this.props.icon || 'tool-tip'}
        />
        <Tooltip
          absolute={true}
          tooltipType={this.props.tooltipType}
          visible={this.state.tooltipVisible}>
          {this.props.children}
        </Tooltip>
      </span>
    );
  }
}
